module.exports = __webpack_public_path__ + "82a87533d1137fa4754f7e7b0b800f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gonglue2.jpg
// module id = 1057
// module chunks = 0